export default (value) => {
  return (value || '').toString().replace(/mins/gim, 'minutes');
};
